import React from 'react';
import { Modal } from 'react-bootstrap-v5';
import { KTSVG } from '../../../../../_mexablock/helpers';

type Props = {
  show: boolean;
  confirmValue: (confirm: boolean) => void;
  onClose?: (closeModal: boolean) => void;
};

const ConfirmModal: React.FC<Props> = ({ show, confirmValue, onClose }) => {
  const handleCancel = () => {
    confirmValue(false);
    onClose?.(true);
  };

  const handleConfirmation = () => {
    confirmValue(true);
  };

  return (
    <Modal show={show} onHide={handleCancel} centered backdrop="static">
      <Modal.Header className="justify-content-center position-relative">
        <div
          className="btn btn-sm btn-icon btn-active-color-primary position-absolute top-0 end-0 m-3"
          onClick={handleCancel}
          role="button"
        >
          <KTSVG
            className="svg-icon-2"
            path="/media/icons/duotune/arrows/arr061.svg"
          />
        </div>
      </Modal.Header>

      <Modal.Body className="text-center">
        <div>
          <KTSVG
            path="/media/svg/files/reloadPackage.svg"
            className="me-4 mt-7"
            svgClassName="w-100px h-100px"
          />
        </div>
        ¿Estás seguro que quieres cancelar la devolución?
        <div className="mt-3 text-muted">
          Las unidades volverán a la ubicación de origen y se eliminará el
          registro de salida creado.
        </div>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <button className="btn btn-light" onClick={handleCancel}>
          Cancelar
        </button>
        <button className="btn btn-primary" onClick={handleConfirmation}>
          Aceptar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export { ConfirmModal };
